import { createSlice } from "@reduxjs/toolkit";

export const accordionSlice = createSlice({
  name: "accordion",
  initialState: {
    expanded: false,
  },
  reducers: {
    setExpanded: (state, action) => {
      state.expanded = action.payload;
    },
  },
});

export const { setExpanded } = accordionSlice.actions;

export default accordionSlice.reducer;
